import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import styles from './filterBlock.css'

import urlify from 'utils/urlify'

import { RadioFilter, SelectFilter } from './'
import PriceSlider from 'components/PriceSlider'

const FilterBlock = (props) => {
  const renderers = {
    radio: RadioFilter,
    range: PriceSlider,
    select: SelectFilter,
    checkbox: RadioFilter
  }
  const {filter, handleClickToggleFilterExpansion} = props
  const {name, type, expanded} = filter
  const wrapperClassNames = classnames(
    styles.wrapper,
    styles[`wrapper-${urlify(name)}`],
    {
      [styles.wrapperExpanded]: expanded,
      [styles.wrapperCollapsed]: !expanded
    }
  )

  const filterWrapperClassNames = classnames(styles.filter, {
    [styles.filterExpanded]: expanded
  })

  return (
    <div
      key={name}
      className={wrapperClassNames}>
      <button
        className={styles.filterTitle}
        onClick={() => handleClickToggleFilterExpansion(filter)}
      >
        {name}
      </button>
      <div className={filterWrapperClassNames}>
        {React.createElement(renderers[type], props)}
      </div>
    </div>
  )
}

FilterBlock.propTypes = {
  filter: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    expanded: PropTypes.bool
  }),
  handleClickToggleFilterExpansion: PropTypes.func
}

export default FilterBlock
